import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChevronRightIconComponent } from '@itero/ui-toolkit-angular/icons';

import { IntuitiveIndication } from '@modules/rx-intuitive-teeth-diagram/models';
import { RxIntuitiveIndicationBadgeComponent } from '../rx-intuitive-indication-badge/rx-intuitive-indication-badge.component';

@Component({
	selector: 'rx-intuitive-treatment-viewlist-item-base',
	templateUrl: './rx-intuitive-treatment-viewlist-item-base.component.html',
	styleUrls: ['../rx-intuitive-tooth-treatment-viewlist-item/rx-intuitive-tooth-treatment-viewlist-item.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, RxIntuitiveIndicationBadgeComponent, ChevronRightIconComponent]
})
export class RxIntuitiveTreatmentViewlistItemBaseComponent {
	@Input() isIndicationVisible = false;

	@Input() indicationId: IntuitiveIndication = IntuitiveIndication.Crown;

	@Input() previewTitle = '';
}
